import React from 'react';
import { Controller, type Control } from 'react-hook-form';
import { AppAdminFormLabel, AppTextArea } from '@/components/atoms';
import { Memo } from '@/components/atoms/AppIcon';
import { MASSAGER_JA } from '@/shared/i18n/massager';
import type { MassagerEditVisitFormData } from '@/schemas/massagerEditVisitSchema';

interface VisitMemoFieldProps {
  control: Control<MassagerEditVisitFormData>;
  disabled: boolean;
  /** Spec caps memo at 255 chars; the textbox itself blocks over-typing. */
  maxLength?: number;
}

/**
 * Memo block: Memo icon + label + free-text textarea.
 * Locked visit → textarea disabled, no input possible.
 */
const VisitMemoField: React.FC<VisitMemoFieldProps> = ({ control, disabled, maxLength = 255 }) => (
  <div className="mt-1">
    <div className="mb-2 flex items-center gap-2">
      <span className="text-lg leading-none text-gray-500">
        <Memo />
      </span>
      <AppAdminFormLabel label={MASSAGER_JA.label.memo} className="!mb-0" />
    </div>
    <Controller
      name="remarks"
      control={control}
      render={({ field }) => (
        <AppTextArea
          rows={12}
          value={field.value ?? ''}
          onChange={e => field.onChange(e.target.value)}
          onBlur={field.onBlur}
          disabled={disabled}
          maxLength={maxLength}
          placeholder="施術内容のメモを入力してください。"
          className="w-full"
        />
      )}
    />
  </div>
);

export default VisitMemoField;
